import { Checkbox, Chip } from "@mui/material";
import AppMUIAutocomplete, {
  AppMUIAutocompleteProps,
} from "./AppMUIAutoComplete";

export interface IconCheckboxOption {
  label: string;
  value: string;
  icon: string;
  groupLabel?: string;
}

type MUIIconCheckboxSelectProps = Omit<
  AppMUIAutocompleteProps<IconCheckboxOption, true, boolean>,
  "multiple"
>;

function MUIIconCheckboxSelect({ ...rest }: MUIIconCheckboxSelectProps) {
  return (
    <AppMUIAutocomplete<IconCheckboxOption, true, boolean>
      multiple
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) => option.label}
      renderValue={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            label={option.label}
            icon={
              <img
                src={option.icon}
                alt="icon"
                className="w-[18px] h-[18px] object-contain"
              />
            }
            {...getTagProps({ index })}
          />
        ))
      }
      renderOption={(props, option, { selected }) => {
        const { key, ...optionProps } = props;
        const isAll = option.value === "all";

        return (
          <li
            key={props.id}
            {...optionProps}
            style={{
              borderBottom: isAll ? "2px solid lightgray" : "none",
            }}
          >
            <Checkbox size="small" color="secondary" checked={selected} />
            <img
              src={option.icon}
              alt="icon"
              className="w-[18px] h-[18px] object-contain me-2"
            />
            {option.label}
          </li>
        );
      }}
      {...rest}
    />
  );
}

export default MUIIconCheckboxSelect;
